import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

const getBreakTypeTitle = (breakType: string): string => {
  switch (breakType) {
    case 'flexible':
      return i18n.t('shift_management.breaks.add_break.flexible.title')
    case 'fixed':
      return i18n.t('shift_management.breaks.add_break.fixed.title')
    case 'semi_flexible':
      return i18n.t('shift_management.breaks.add_break.semi_flexible.title')
    default:
      return ''
  }
}

interface Props {
  form: PlannedBreakForm
}
const BreakDetailsIcon = ({ form }: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useToggle(false)

  return (
    <Tooltip.Alt
      attachment="bottom center"
      open={isTooltipOpen}
      toggle={setIsTooltipOpen}
      label={
        <Box flexDirection="column" gap="s4">
          <Text size="100" color="grey000White">
            {form.get('break_configuration.paid').value
              ? i18n.t('company_settings.time.breaks.paid')
              : i18n.t('company_settings.time.breaks.unpaid')}
          </Text>
          <Text size="100" color="grey000White">
            {form.get('break_configuration.name').value}
          </Text>
          <Text size="100" color="grey000White">
            {getBreakTypeTitle(form.get('break_type').value)}
          </Text>
        </Box>
      }
    >
      <Icon.Medium icon="coffee" color="grey1000" />
    </Tooltip.Alt>
  )
}

export default BreakDetailsIcon
